export default "__VITE_ASSET__f2162b47__"